export enum DoBoxWorkKind {
  REPLY_INFO = 'REPLY_INFO',
  SCHEDULE = 'SCHEDULE',
  DECIDE_APPROVE = 'DECIDE_APPROVE',
  RESEARCH = 'RESEARCH',
  UPDATE_EXTERNAL_TOOL = 'UPDATE_EXTERNAL_TOOL',
  CODE_CHANGE = 'CODE_CHANGE',
  WRITE_DOCUMENT = 'WRITE_DOCUMENT',
  FOLLOW_UP = 'FOLLOW_UP',
  FYI = 'FYI',
  OTHER = 'OTHER',
}

export enum DoBoxWaitingOn {
  REQUESTER = 'REQUESTER',
  TARGET_USER = 'TARGET_USER',
  THIRD_PARTY = 'THIRD_PARTY',
  NOBODY = 'NOBODY',
}

export const MISSING_INFO_MAX_ITEMS = 3;
export const MISSING_INFO_ITEM_MAX_CHARS = 160;

/** Tolerant parse of a signal's missingInfo JSON column: invalid JSON or a
 *  non-array result is treated as "no missing info" rather than thrown on,
 *  since this reads a value an LLM wrote. Caps are enforced here rather than
 *  trusted from the source, for the same reason. */
export function parseMissingInfo(json: string | null | undefined): string[] {
  if (!json) {
    return [];
  }
  let parsed: unknown;
  try {
    parsed = JSON.parse(json);
  } catch {
    return [];
  }
  if (!Array.isArray(parsed)) {
    return [];
  }
  return parsed
    .filter((item): item is string => typeof item === 'string')
    .slice(0, MISSING_INFO_MAX_ITEMS)
    .map((item) =>
      item.length > MISSING_INFO_ITEM_MAX_CHARS
        ? item.slice(0, MISSING_INFO_ITEM_MAX_CHARS)
        : item,
    );
}
